import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/reset.css";
import "./index.css";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";

import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ChakraProvider disableGlobalStyle>
    <App />
  </ChakraProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
